<template>
  <div class="w100m">
    <div class="w100 flexVC" v-if="$store.state.isPc">
      <div class="header">
        <el-image
          class="header-img"
          :src="aboutImg"
          :fit="cover"></el-image>
        <div class="header-content flexVC">
          <img :src="logoImg" class="logo">
          <div class="marT50">创建正向生活</div>
          <div class="marT10">{{content}}</div>
        </div>
      </div>
      <div class="fontS32 fontW6 C000A85">发展历程</div>
      <div class="C000A25 fontW3 fontS32 marT80">2008</div>
      <div class="about2">
        <div class="clear-fix-time">
          <div class="hide-box"></div>
          <ul class="clear-fix-time">
            <li>
              <div class="flexHRC">
                <div class="h-line"></div>
                <h4 class="fontS24">2008年：公司成立</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3">趁早前身「北京目后佐道设计顾问有限公司」注册成立</p>
            </li>
            <li>
              <div class="flexHRC">
                <h4 class="fontS24">2011年：第1本“趁早效率手册”诞生</h4>
                <div class="h-line"></div>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3">
                “趁早小店”和效率手册诞生，趁早精神理念逐渐萌芽。趁早效率手册浓缩了趁早精神的精髓，作为爆款核心产品，销量逐年倍增，与此同时产品线也在根据用户的需求，不断拓展和尝试，囊括服装类、手册类、覆盖各个生活场景的表单品类和塑身类</p>
            </li>

            <li>
              <div class="flexHRC">
                <div class="h-line"></div>
                <h4 class="fontS24">2013年：正式建立趁早品牌</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3"
                 style="display: flex;justify-content: flex-end;">公司正式更名为趁早（北京）科技有限公司 </p>
              <p class="C000A45 marT10 fontS16 fontW3"
                 style="display: flex;justify-content: flex-end;">首次「趁早PARTY」在798举办</p>
              <p class="C000A45 marT10 fontS16 fontW3"
                 style="display: flex;justify-content: flex-end;">「趁早」品牌正式发布运营，趁早网1.0上线</p>
              <p class="C000A45 marT10 fontS16 fontW3"
                 style="display: flex;justify-content: flex-end;">从产品型公司转变去中心化的互联网社群企业</p>
            </li>
            <li>
              <div class="flexH w100">
                <div class="h-line"></div>
                <h4 class="fontS24">2014年：「最具创新奖」</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3 w100">9月，获得阿里巴巴天下网商举办的电商大爆炸比赛五强及「最具创新奖」</p>
            </li>
            <li>
              <div class="flexHRC w100">
                <div class="h-line"></div>
                <h4 class="fontS24">2015年</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3 "
                 style="display: flex;justify-content: flex-end;">趁早获得《OK!》年度挚爱励志品牌奖</p>
              <p class="C000A45 marT10 fontS16 fontW3 "
                 style="display: flex;justify-content: flex-end;">获亚杰商会摇篮计划“成长潜力”奖</p>
              <p class="C000A45 marT10 fontS16 fontW3 "
                 style="display: flex;justify-content: flex-end;">获2000万A轮融资</p>
            </li>
            <li>
              <div class="flexH w100">
                <div class="h-line"></div>
                <h4 class="fontS24">2017年</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3">2月，旗下SHAPEYOURLIFE品牌之五皇冠淘宝店荣获IFashion新锐好店奖
                11月，ShapeGirl马甲线大赛获得第四届中国创新传播金奖 12月，新浪微博2017十大影响力运动健身大V奖</p>
            </li>
            <li>
              <div class="flexHRC w100">
                <div class="h-line"></div>
                <h4 class="fontS24">2018年</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3 "
                 style="display: flex;justify-content: flex-end;"> 6月，环球女性安全出行最佳女子关怀组织奖</p>
            </li>
            <li>
              <div class="flexH w100">
                <div class="h-line"></div>
                <h4 class="fontS24">2019年</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3 w100">2018-2019年，趁早连续两年获得BSOC中国文具大赏十强</p>
            </li>
            <li>
              <div class="flexHRC w100">
                <div class="h-line"></div>
                <h4 class="fontS24">2020年</h4>
              </div>
              <p class="C000A45 marT10 fontS16 fontW3 "
                 style="display: flex;justify-content: flex-end;"> 趁早十周年</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="C000A25 fontW3 fontS32 marT50" style="padding-bottom: 80px;">FUTURE</div>
      <shape-footer></shape-footer>
    </div>
    <!--  移动端  -->
    <div class="w100m BFFF flexVC" v-if="!$store.state.isPc">
      <div class="header-m">
        <el-image
          class="header-img"
          :src="aboutImg"
          :fit="cover"></el-image>
        <div class="header-content flexVC">
          <img :src="logoImg" class="logo-m">
        </div>
      </div>
      <div class="fontS32m fontW6 C000A85">发展历程</div>
      <div class="C000A25 fontW3 fontS32m" style="margin-top: 0.8rem;">2008</div>
      <div class="about2-m">
        <div class="clear-fix-time-m">
          <div class="hide-box-m"></div>
          <ul class="clear-fix-time-m">
            <li>
              <div class="flexHRC">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2008</h4>
              </div>
              <div class="flexHRC">
                <p class="C000A45 marT10m fontS24m fontW3"
                   style="display: flex;justify-content: flex-end;">公司成立 </p>
              </div>
            </li>
            <li>
              <div class="flexH">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2011</h4>
              </div>
              <p class="C000A45 marT10m fontS24m fontW3">第1本“趁早效率手册”诞生</p>
            </li>

            <li>
              <div class="flexHRC">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2013</h4>
              </div>
              <div class="flexHRC">
                <p class="C000A45 marT10m fontS24m fontW3"
                   style="display: flex;justify-content: flex-end;">公司变更正式建立趁早品牌 </p>
              </div>
            </li>
            <li>
              <div class="flexH w100">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2014 </h4>
              </div>
              <p class="C000A45 marT10m fontS24m fontW3 w100">阿里巴巴电商大爆炸比赛五强及「最具创新奖」</p>
            </li>
            <li>
              <div class="flexHRC w100">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2015 </h4>
              </div>
              <div class="flexHRC">
                <p class="C000A45 marT10m fontS24m fontW3 "
                   style="display: flex;justify-content: flex-end;">获2000万A轮融资</p>
              </div>
            </li>
            <li>
              <div class="flexH w100">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2017</h4>
              </div>
              <p class="C000A45 marT10m fontS24m fontW3">ShapeGirl马甲线大赛获得第四届中国创新传播金奖</p>
            </li>
            <li>
              <div class="flexHRC w100">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2018-2019</h4>
              </div>
              <div class="flexHRC">
                <p class="C000A45 marT10m fontS24m fontW3 w100">趁早连续两年获得BSOC中国文具大赏十强</p>
              </div>
            </li>
            <li>
              <div class="flexH w100">
                <div class="h-line-m"></div>
                <h4 class="fontS24m">2020</h4>
              </div>
              <p class="C000A45 marT10m fontS24m fontW3 "> 趁早十周年</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="C000A25 fontW3 fontS32m " style="padding-bottom: 80px;margin-top: 0.5rem;">FUTURE</div>
      <shape-footer></shape-footer>
    </div>
  </div>

</template>

<script>
  import logoImg from '@/assets/images/icon_about_logo.png'
  import shapeFooter from '@/components/ShapeFooter'

  export default {
    name: "About",
    data() {
      return {
        cover: 'cover',
        aboutImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20201007122129.png',
        logoImg: logoImg,
        content: '通过线上线下内容，以及配套创新型的文创产品、线上陪伴式目标达成工具、支持使用者养成习惯，抵达目标',
      }
    },

    components: {
      shapeFooter,
    },

    mounted() {
      window.scrollTo(0, 0);
      if (!this.$store.state.isPc) {
        this.$store.commit('isAlphaEdit', true)
      }
      this.$store.commit('edit', 0)
    }

  }
</script>

<style scoped>

  .header {
    width: 100%;
    height: 600px;
    position: relative;
    margin-bottom: 80px;
  }

  .header-img {
    width: 100%;
    height: 100%;
  }

  .header-content {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }

  .logo {
    width: 128px;
    height: 128px;
  }

  .marT80 {
    margin-top: 80px;
  }

  .fontS32 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS24 {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS16 {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .C000A85 {
    color: rgba(0, 0, 0, 0.85);
  }

  .C000A25 {
    color: rgba(0, 0, 0, 0.15);
  }

  .C000A45 {
    color: rgba(0, 0, 0, 0.45);
  }

  .fontW6 {
    font-weight: 600;
  }

  .fontW3 {
    font-weight: 300;
  }

  .left-item {
    width: 496px;
  }

  .right-item {
    width: 496px;
  }

  .content {
    width: 380px;
  }

  .h-line {
    width: 40px;
    height: 1px;
    background: #000000;
    margin-left: 32px;
    margin-right: 32px;
    margin-top: 24px;
  }

  .flexVR {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  /*  *****************************/
  .hide-box {
    width: 40px;
    height: 40px;
    background: #ffffff;
    position: absolute;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    z-index: 200;
  }

  .clear-fix-time {
    width: 1000px;
    display: list-item;
    zoom: 1;
    position: relative;
  }

  .clear-fix-time:after {
    content: '\20';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0
  }

  .about2 {
    /*padding-bottom: 80px*/
  }

  .about2 .tit {
    text-align: center
  }

  .about2 ul {
    background: url(../../assets/images/icon_time_line.png) repeat-y center
  }

  .about2 .tit h6 {
    color: rgba(0, 0, 0, 0.45);
  }

  .about2 .tit h5 {
    color: #333;
    margin: 15px 0 45px;
  }

  .about2 li:before {
    background: #d70050;
    border: 8px solid #F0F0F0;
    border-radius: 50%;
    right: -24px;
    top: 12px;
    left: auto;
    content: "";
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    z-index: 200;
  }

  .about2 li h4:hover {
    color: #f8f8f8;
    transition: all 1s;
    transform: translateY(-15px)
  }

  .about2 li h4 {
    position: relative;
    display: block;
    text-decoration: none;
    font-family: lato;
    color: #ecf0f1;
    text-transform: uppercase;
    padding: 4px 0;
    transition: .5s
  }

  .about2 li h4::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 1px;
    top: 100%;
    left: 0;
    background: #d70050;
    transition: transform .5s;
    transform: scaleX(0);
    transform-origin: left;
  }

  .about2 li h4:hover {
    color: #95a5a6
  }

  .about2 li h4:hover::after {
    transform: scaleX(1);
    transform-origin: right;
  }

  .about2 li:nth-child(2n):before {
    /*background: url(../../assets/images/icon_time_point.png) no-repeat center center;*/
    background: #d70050;
    border: 8px solid #F0F0F0;
    border-radius: 50%;
    left: -24px;
    top: 12px;
    content: "";
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    z-index: 200;
  }

  .about2 li h4 {
    color: #333;
    transition: all 1s
  }

  .about2 li:nth-child(2n + 1) p {
    color: rgba(0, 0, 0, 0.45);
    font-family: PingFangSC-Light, PingFang SC;
    margin-top: 10px;
    display: -webkit-box;
    margin-right: 105px;
  }

  .about2 li:nth-child(2n) p {
    width: 384px;
    color: rgba(0, 0, 0, 0.45);
    font-family: PingFangSC-Light, PingFang SC;
    margin-top: 10px;
    display: -webkit-box;
    margin-left: 105px;
  }

  .future {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin-top: 17px
  }

  .about2 li:nth-child(1) {
    /*margin-top: -15px;*/
  }

  .about2 li {
    /*float: left;*/
    width: 49%;
    text-align: right;
    position: relative;
    margin-top: 100px
  }

  .about2 li:nth-child(2n) {
    /*float: right;*/
    margin-left: 51%;
    text-align: left;
    margin-top: 90px
  }

  .flexHRC {
    display: flex;
    flex-direction: row-reverse;
  }

  /*  ******************************/

  /* ************************mobile*************************** */
  .header-m {
    width: 100%;
    height: 4rem;
    position: relative;
    margin-bottom: 0.8rem;
  }

  .logo-m {
    width: 1.24rem;
    height: 1.24rem;
  }

  .fontS32m {
    font-size: 0.32rem;
  }

  .h-line-m {
    width: 0.32rem;
    height: 1px;
    background: #000000;
    margin-left: 0.18rem;
    margin-right: 0.18rem;
    margin-top: 0.24rem;
  }

  .fontS24m {
    font-size: 0.24rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .marT10m{
    margin-top: 0.1rem;
  }

  /*  ********************** f0f2f5 *******/
  .hide-box-m {
    width: 0.3rem;
    height: 0.3rem;
    background: #fff;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 200;
  }

  .clear-fix-time-m {
    width: 100%;
    display: list-item;
    zoom: 1;
    position: relative;
  }

  .clear-fix-time-m:after {
    content: '\20';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0
  }

  .about2-m {
    /*padding-bottom: 80px*/
    width: 100%;
  }

  .about2-m .tit {
    text-align: center
  }

  .about2-m ul {
    background: url(../../assets/images/icon_time_line.png) repeat-y center
    /*background: rgba(0,0,0,.15);*/
  }

  .about2-m .tit h6 {
    color: rgba(0, 0, 0, 0.45);
  }

  .about2-m .tit h5 {
    color: #333;
    margin: 0.15rem 0 0.45rem;
  }

  .about2-m li:before {
    background: #d70050;
    border: 0.10rem solid #F0F0F0;
    border-radius: 50%;
    right: -0.24rem;
    top: 0.10rem;
    left: auto;
    content: "";
    display: block;
    position: absolute;
    width: 0.12rem;
    height: 0.12rem;
    z-index: 200;
  }

  .about2-m li h4:hover {
    color: #f8f8f8;
    transition: all 1s;
    transform: translateY(-0.15px)
  }

  .about2-m li h4 {
    position: relative;
    display: block;
    text-decoration: none;
    font-family: lato;
    color: #ecf0f1;
    text-transform: uppercase;
    padding: 0.04rem 0;
    transition: .5s
  }

  .about2-m li h4::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 0.01rem;
    top: 100%;
    left: 0;
    background: #d70050;
    transition: transform .5s;
    transform: scaleX(0);
    transform-origin: left;
  }

  .about2-m li h4:hover {
    color: #95a5a6
  }

  .about2-m li h4:hover::after {
    transform: scaleX(1);
    transform-origin: right;
  }

  .about2-m li:nth-child(2n):before {
    /*background: url(../../assets/images/icon_time_point.png) no-repeat center center;*/
    background: #d70050;
    border: 0.10rem solid #F0F0F0;
    border-radius: 50%;
    left: -0.24rem;
    top: 0.12rem;
    content: "";
    display: block;
    position: absolute;
    width: 0.12rem;
    height: 0.12rem;
    z-index: 200;
  }

  .about2-m li h4 {
    color: #333;
    transition: all 1s
  }

  .about2-m li:nth-child(2n + 1) p {
    width: 2.55rem;
    color: rgba(0, 0, 0, 0.45);
    font-family: PingFangSC-Light, PingFang SC;
    margin-top: 0.10rem;
    display: -webkit-box;
    margin-right: 0.7rem;
    text-align: right;
  }

  .about2-m li:nth-child(2n) p {
    width: 2.55rem;
    color: rgba(0, 0, 0, 0.45);
    font-family: PingFangSC-Light, PingFang SC;
    margin-top: 0.10rem;
    display: -webkit-box;
    text-align: left;
    margin-left: 0.7rem;
  }

  .future {
    text-align: center;
    color: #999;
    font-size: 0.12rem;
    margin-top: 0.17rem;
  }

  .about2-m li:nth-child(1) {
    /*margin-top: -15px;*/
  }

  .about2-m li {
    /*float: left;*/
    width: 49%;
    text-align: right;
    position: relative;
    margin-top: 0.01rem;
  }

  .about2-m li:nth-child(2n) {
    /*float: right;*/
    margin-left: 51%;
    text-align: left;
    margin-top: 0.90rem;
  }

  /*  ******************************/

  /*  *****************************************************/

</style>



// WEBPACK FOOTER //
// src/page/about/About.vue